'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/table/style/css');

var _table = require('antd/lib/table');

var _table2 = _interopRequireDefault(_table);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderOperation = _react2.default.createClass({
    displayName: 'OrderOperation',
    render: function render() {
        var columns = [{
            title: '时间',
            key: '0',
            dataIndex: 'created_at'
        }, {
            title: '操作人',
            key: '1',
            dataIndex: 'operate_user.name'
        }, {
            title: '记录',
            key: '2',
            dataIndex: 'log'
        }];
        var tableConfig = {
            columns: columns,
            dataSource: this.props.operations,
            pagination: false,
            bordered: true,
            rowKey: function rowKey(record) {
                return record.created_at;
            }
        };
        return _react2.default.createElement(_table2.default, tableConfig);
    }
}); /**
     * 订单操作记录信息
     */

exports.default = OrderOperation;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/order_operation.js
// module id = 1191
// module chunks = 0